import { environment } from '~env/environment';

export const METRO_APPS_COOKIE_DISCLAIMER_WEB_COMPONENT = () =>
  `${environment.metroAppsBaseUrl()}/data/apps/metro?sc_device=webcomponent&components=cookie%20disclaimer&skipReload=1`;
export const METRO_APPS_FLYOUT_WEB_COMPONENT = () =>
  `${environment.metroAppsBaseUrl()}/data/apps/metro?sc_device=webcomponent&components=user%20profile&sso=1&hotjar=1`;
